// A phone offers its owner's own contact card on any field it reads as a name,
// a number or an address: right where the person typing IS the guest (§12),
// wrong where staff are typing somebody else's (§10). `autocomplete="off"` is
// advisory and iOS ignores it; a value it cannot map to a contact does stop it.
export const NOT_A_CONTACT = {
  autoComplete: 'new-password',
  autoCorrect: 'off',
  spellCheck: false,
} as const;

// A staff field is named after the row of the form, never after what it holds.
export const STAFF_FIELD_NAMES = {
  guest: 'reserve-1',
  phone: 'reserve-2',
  email: 'reserve-3',
} as const;

// A visitor is filling in their own details, so their phone should help. §12
export const OWN_CONTACT = {
  name: { autoComplete: 'name', name: 'name' },
  email: { autoComplete: 'email', name: 'email' },
  phone: { autoComplete: 'tel', name: 'tel' },
} as const;
